import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"

const resumensinc = {
    getResumenSinc: async () =>
    axios({
        'method':'GET',
        'url':apiurl + "/resumenSinc",
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer " + (await fetchAuthSession()).tokens?.idToken?.toString()
        },
        'crossdomain': true,
    })
};

export default resumensinc;